import joi from 'joi';
import { Currency } from 'interfaces/common';

const SAR: Currency = 'SAR';
const currencySchema = joi.string().default(SAR);

export default currencySchema;
